import { Link } from "react-router-dom";

export function Terms() {
  return (
    <div className="auth-shell">
      <div className="terms-card">
        <div className="terms-header">
          <h1 className="terms-title">Terms &amp; Conditions</h1>
          <p className="terms-meta">Last updated: May 2026</p>
        </div>

        <div className="terms-body">
          <section>
            <h2>1. Beta service</h2>
            <p>
              X·Ring is currently in <strong>public beta</strong>. The service is provided
              for evaluation and early-access use. Features may change, be removed, or
              behave unexpectedly. <strong>We make no guarantee of bug-free operation,
              uninterrupted availability, or the preservation of your data.</strong> You
              should not rely on X·Ring as your sole record of competition scores or
              equipment configurations.
            </p>
          </section>

          <section>
            <h2>2. No warranty</h2>
            <p>
              The service is provided <strong>"as is"</strong> and <strong>"as
              available"</strong> without warranty of any kind, express or implied,
              including but not limited to warranties of merchantability, fitness for a
              particular purpose, or non-infringement. Use of X·Ring is at your own risk.
            </p>
          </section>

          <section>
            <h2>3. Limitation of liability</h2>
            <p>
              To the fullest extent permitted by applicable law, X·Ring and its operators
              shall not be liable for any indirect, incidental, special, consequential, or
              punitive damages, or any loss of data, arising out of or in connection with
              your use of the service.
            </p>
          </section>

          <section>
            <h2>4. Your data</h2>
            <p>
              X·Ring stores the archery session data you enter (scores, arrow positions,
              equipment details, and account information) solely to provide the service to
              you. We do not sell your data to third parties. During the beta period,
              data may be reset or lost due to infrastructure changes; we will make
              reasonable efforts to notify users in advance of any planned data resets.
            </p>
          </section>

          <section>
            <h2>5. Account responsibility</h2>
            <p>
              You are responsible for maintaining the confidentiality of your login
              credentials and for all activity that occurs under your account. Notify us
              immediately if you suspect unauthorised access.
            </p>
          </section>

          <section>
            <h2>6. Acceptable use</h2>
            <p>
              You agree not to use the service for any unlawful purpose, to attempt to
              gain unauthorised access to any part of the service, or to interfere with
              the service's operation.
            </p>
          </section>

          <section>
            <h2>7. Changes to these terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of X·Ring after
              changes are posted constitutes acceptance of the revised Terms. We will
              notify registered users of material changes by email where practicable.
            </p>
          </section>

          <section>
            <h2>8. Contact</h2>
            <p>
              Questions about these Terms can be directed to the project maintainer via
              the feedback form within the app.
            </p>
          </section>
        </div>

        <div className="terms-footer">
          <Link to="/signup" className="btn primary">Back to sign up</Link>
        </div>
      </div>
    </div>
  );
}
